export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>
        Элегантный синтетический гобелен размером 180x145 см. Благодаря легкой ткани, гобелен без особых сложностей и специальных инструментов можно повесить на любую стену. Рисунок наносится на одну сторону.
        </p>
        <p>
          Материалы:
          Интерлок МФ 135.
        </p>
        <p>
          Размеры:
          180x145 см.
        </p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `
        <p>Способ печати - сублимация. Принт становится частью ткани и не чувствуется на ощупь. Картинка получается яркой и сочной. Изображение не стирается, не выцветает и не трескается.</p>
        <p>Можно гладить утюгом и стирать в машинке.</p>
      `
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
